module.exports = __webpack_public_path__ + "friendFinderApp.png?1df7daee918ce0491988008a1fe98840";